<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="ch16"></a><a id="page_17"></a><a href="#/contents#ch16"><b>Fighting Women</b></a></h2>
<p class="noindent"><span>First women’s boxing match in the United States: 1876 in New York City. The prize was a silver butter dish.</span></p>
<p class="noindent"><span>First female boxing star: Barbara Buttrick, from England. She was 5'0" and weighed 100 pounds. In 1954, in a match in Canada, she fought in the first female boxing bout broadcast on the radio.</span></p>
<p class="noindent"><span>In 1987, former world women’s lightweight champion Marion “Lady Tyger” Trimiar staged a hunger strike outside promoter Don King’s New York office. She wanted more money and better promotion for female boxers. (It worked.)</span></p>
<p class="noindent"><span>Three female boxers have famous prizefighters for dads: Laila Ali (daughter of Muhammad Ali), Jacqui Frazier-Lyde (daughter of Joe Frazier), and Freeda Foreman (daughter of George Foreman).</span></p>
<p class="noindent"><span>During her boxing training for <i>Million Dollar Baby</i>, actress Hillary Swank gained about 20 pounds…most of it pure muscle.</span></p>
<p class="noindent"><span>Three rules that make women’s boxing different from men’s: 1) Women have to wear breast protectors; 2) They must prove they aren’t pregnant; and 3) Rounds last two minutes instead of three.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter16.vue?6f2ffc08